import { ModuleClickAction, ModuleContent } from '../contract';

export type ButtonModuleContent = {
	buttonText: string;
	buttonLink: string;
	buttonType: 'Website' | 'Phone' | 'Email' | 'Broadcast' | 'SelectValue';
	selectionGroup?: string;
	useSelectedValues?: boolean;
	openLinkNew: boolean;
};

export function isButtonModuleContent(content: ModuleContent): content is ButtonModuleContent {
	const buttonContent = content as Partial<ButtonModuleContent>;
	return typeof buttonContent.buttonText === 'string' && typeof buttonContent.buttonLink === 'string';
}

export function getButtonModuleClickAction(content: ButtonModuleContent): ModuleClickAction | undefined {
	if (content.buttonType === 'SelectValue')
		return { type: 'select-value', group: content.selectionGroup ?? '', value: content.buttonLink };
	const buttonLink = content.buttonLink.trim();
	if (!buttonLink && !(content.buttonType === 'Website' && content.useSelectedValues)) return undefined;

	switch (content.buttonType) {
		case 'Phone':
			return { type: 'link', link: { type: 'url', href: `tel:${buttonLink}` } };
		case 'Email':
			return { type: 'link', link: { type: 'url', href: `mailto:${buttonLink}` } };
		case 'Broadcast': {
			const eventNames = buttonLink
				.split(',')
				.map((eventName) => eventName.trim())
				.filter(Boolean);

			return eventNames.length > 0 ? { type: 'dispatch-events', eventNames } : undefined;
		}
		case 'Website':
		default:
			return {
				type: 'link',
				useSelectedValues: content.useSelectedValues,
				link: {
					type: 'url',
					href: buttonLink,
					target: content.openLinkNew ? '_blank' : undefined,
				},
			};
	}
}

export function getButtonModuleIndexableText(content: ModuleContent): string {
	if (!isButtonModuleContent(content)) return '';
	return content.buttonText.trim();
}
